<i class="py-2 mx-2 fa-fw"
   [ngStyle]="{ color: applyZoneColor ? zoneColour : undefined }"
   [ngClass]="[zoneIcon]"></i>
<span class="zone-text">{{ zoneText }}</span>
